export default {
  props: {
    /**
     * The Image orientation horizontal/vertical
     */
    orientation: {
      type: String,
      required: false,
      default: undefined
    }
  },
  computed: {
    /**
     * The Height of the viewer
     */
    viewerHeight() {
      if (this.componentType == "Portrait") {
        return "60vh";
      } else {
        return "32em";
      }
    }
  }
};
